import { IconSidebar } from 'featherico';
import { useState } from 'react';
import NotificationsTrigger from '../../react/components/Notifications/NotificationsTrigger/withProvider';
import GlobalCreate from '../../react/features/AppHeader/components/GlobalCreate';
import HelpMenu from '../../react/features/AppHeader/components/HelpMenu';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import HeaderSearchBar from '../../react/features/HeaderSearchBar/container';
import { JustLaunchedBubble } from '../../react/features/JustLaunched';
import { NavItemButton } from '../../react/features/Navigation/Item';
import { useAppContext } from '../../react/hooks/useAppContext';
import { isFeatureEnabled } from '../../react/services/Features';
import styles from './style.m.less';

type Props = {
    onCollapse: () => void;
};

export default function Actions({ onCollapse }: Props) {
    const [searchFocused, setSearchFocused] = useState(false);
    const { user } = useAppContext();

    return (
        <div className={styles.container}>
            <JustLaunchedBubble />

            <div className={styles.actions}>
                {!user.isGuest && (
                    <>
                        {!searchFocused && <GlobalCreate user={user} />}
                        <HeaderSearchBar
                            onFocus={() => setSearchFocused(true)}
                            onBlur={() => setSearchFocused(false)}
                        />
                    </>
                )}
                {!searchFocused && (
                    <>
                        <HelpMenu />
                        <NotificationsTrigger />
                    </>
                )}
            </div>

            {isFeatureEnabled('FEATURE_navigationCompact') ? (
                <div className={styles.userMenuWrapper}>
                    <UserMenu user={user} />
                    <NavItemButton icon={<IconSidebar />} label="Collapse Navigation" compact onClick={onCollapse} />
                </div>
            ) : (
                <UserMenu user={user} />
            )}
        </div>
    );
}
